import { connectRouter } from "connected-react-router";
import { History } from "history";
import { IndexProfileListItem } from "humboldt";
import { combineReducers } from "redux";
import { IAuthState } from "../auth/model";
import auth from "../auth/reducer";
import { AppAction, TypeKeys } from "./actionTypes";

export interface AppState {
    auth?: IAuthState;
    isLoadingProfileList: any;
    profileList: IndexProfileListItem[];
    selectedProfileId?: string;
    searchError?: boolean;
}

export const appInitialState: AppState = {
    isLoadingProfileList: false,
    profileList: [],
    selectedProfileId: undefined,
    searchError: undefined,
};

export function app(
    state: AppState = appInitialState,
    action: AppAction,
): AppState {
    switch (action.type) {
        case TypeKeys.LOAD_PROFILE_LIST:
            return { ...state, isLoadingProfileList: true };
        case TypeKeys.RECEIVE_PROFILE_LIST:
            return {
                ...state,
                isLoadingProfileList: false,
                profileList: action.profileList,
                searchError: action.searchError,
            };
        case TypeKeys.USER_SELECTED_PROFILE_ID:
            return { ...state, selectedProfileId: action.profileId };
        default:
            return state;
    }
}

export const rootReducer = (history: History) => combineReducers({
    auth,
    app,
    router: connectRouter(history),
});
